<template>
    <div
        v-show="isOk"
        :class="'popup ' + (propClassname || '') + ' ' + ((isShow || false) ? 'popup-show' : '') + ' ' + ((propAnimation || true) ? 'animation': '' )"
        :disable-scroll="propDisablescroll">
        <div class="popup-mask"
              :style="topStyle"
              v-if="propMask || true" @click="on_mask_tap">
        </div>
        <div
            :class="'popup-content bottom-line-exclude popup-' + (propPosition || 'bottom')+ ' '+(propIsBar ? 'popup-bar' : '')"
            :style="'width:'+width+';'+(['left','right'].includes(propPosition)?topStyle:'')">
            <Icon type="md-close" @click="on_mask_tap" v-if="showCloseIcon" color="#DBDDE0" class="popup-close pa" size="18" />
            <div v-if="title" class="tc txt-size-16 fw-b cr-white pd-t-30 mr-h-30 pd-b-10 br-b br-gray-666">{{ title }}</div>
            <slot></slot>
            <div v-if="showButton"
                  class="modal-button-group oh br-t txt-size-18 fw-b tc">
                <div class="w-50 modal-button fl br-r bs-bb" @click="on_mask_tap">取消</div>
                <div class="w-50 modal-button fr cr-primary" @click="handle_sure">确定</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        showButton: {
            type: Boolean,
            default: false
        },
        title: { type: String, default: '' },
        propClassname: {
            type: String,
            default: ''
        },
        showCloseIcon: {
            type: Boolean,
            default: true
        },
        propPosition: {
            type: String,
            default: 'bottom'
        },
        propMask: {
            type: Boolean,
            default: true
        },
        propAnimation: {
            type: Boolean,
            default: true
        },
        propDisablescroll: {
            type: Boolean,
            default: false
        },
        top: {
            type: [Number, String],
            default: 0
        },
        width: {
            type: [Number, String],
            default: '100%'
        },
        propIsBar: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        topStyle() {
            let top = this.top, unit = 'px';
            if (typeof top === 'string') unit = '';
            if (top) {
                return `top:${ top }${ unit };`;
            }
            return '';
        }
    },
    data(){
        return{
            isOk:true,
        }
    },
    methods: {
        // 事件处理
        on_mask_tap() {
            this.$emit('update:isShow', false);
        },
        handle_sure() {
            this.$emit('on-ok')
        },
    },
};
</script>
<style>
@import './u-popup.css';
</style>
